import $ from 'jquery';

const namespace = 'plusminus';

export default class PlusMinus {
  state = {
    initialValue: null,
  };

  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          action: '[data-action]',
          field: '.plus-minus__field',
          trackProduct: '[data-track-product]',
          update: '.cart-item__update-button',
        },
        classes: {
          changed: 'has-changed',
        },
        minValue: 1,
      },
      options,
    );

    this.$el = $(el);
    this.$field = $(this.options.selectors.field, this.$el);
    this.$product = this.$el.closest(this.options.selectors.trackProduct);
    this.state.initialValue = parseInt(this.$field.val(), 10);
    this.minValue = this.$field.attr('min') || this.options.minValue;
    this.updateEl = this.$product[0].querySelector(this.options.selectors.update);

    this.bind();
  }

  /**
   * Apply event listeners
   */
  bind() {
    this.pushToDataLayer = this.pushToDataLayer.bind(this);

    this.$el.on(
      `click.${namespace}`,
      this.options.selectors.action,
      this.handleClick.bind(this),
    );

    this.$el.on(
      `change.${namespace}`,
      this.options.selectors.field,
      this.handleFieldChange.bind(this),
    );

    this.updateEl.addEventListener('click', this.pushToDataLayer);
  }

  /**
   * @param {Event} event
   */
  handleClick(event) {
    const {currentTarget} = event;
    const action = $(currentTarget).data('action');

    if (action === 'minus') {
      this.update(-1);
      return;
    }

    this.update(+1);
  }

  /**
   * @param {Event} event
   */
  handleFieldChange(event) {
    const {currentTarget} = event;
    const $target = $(currentTarget);
    const val = parseInt($target.val(), 10);

    this.decorate(val);
  }

  /**
   * Update the value with the given operation
   * @param {Number} op
   */
  update(op) {
    const val = parseInt(this.$field.val(), 10);
    let newVal = val;

    if (val + op <= this.minValue || isNaN(val)) {
      newVal = this.minValue;
    } else {
      newVal = val + op;
    }

    this.$field.val(newVal);
    this.decorate(newVal);
  }

  /**
   * @param {Number} val
   */
  decorate(val) {
    this.$el.toggleClass(
      this.options.classes.changed,
      val !== this.state.initialValue,
    );
  }

  pushToDataLayer() {
    const productData = this.$product.data('trackProduct');
    productData.quantity = this.$field.val().toString();
    window.dataLayer.push({
      event: 'change_cart_quantity',
      ecommerce: {
        items: [
          productData,
        ],
      },
    });
  }
}
